import { AccountRestrictedComponent } from "./AccountRestricted";

export const AccountRestricted = AccountRestrictedComponent;